<div class="modal-overlay">
  <div class="modal-box">
    <h2 class="modal-title">Review Your Payment</h2>
    <div class="mentor-card">
      <div class="mentor-avatar">RK</div>
      <div>
        <p class="mentor-name">Rajesh Kumar</p>
        <p class="mentor-role">Senior Software Engineer at Google</p>
      </div>
    </div>

    <div class="session-card">
      <h3 class="session-title">Payment Summary</h3>

      <div class="detail-row">
        <span class="label">Session Cost</span>
        <span class="value"> <i class="bi bi-currency-rupee"></i>0 </span>
      </div>

      <div class="divider"></div>

      <div class="detail-row">
        <span class="label">Amount To Pay</span>
        <span class="value"> <i class="bi bi-currency-rupee"></i>0 </span>
      </div>
    </div>

    <div class="modal-actions d-flex justify-content-between">
      <button class="cancel-btn">← Back</button>
      <button
        class="review-btn"
        (click)="OpenReviewBookingForm()"
        *hasPermission="PermissionForStudents.MENTOR_BOOK"
      >
        Confirm Booking
      </button>
    </div>
  </div>
</div>
